
import { computed, defineComponent, watch, PropType } from 'vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import MagazineCardList from '@/components/block/MagazineCardList.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Keywords from '@/components/elements/Keywords.vue'
import { useSpecial } from '@/provider/special'
import { MagazineSpecialCategory } from '@/types/MagazineSpecial'

export default defineComponent({
  name: 'MagazinesFooter',

  props: {
    categories: {
      type: Array as PropType<MagazineSpecialCategory[]>,
      default: () => []
    }
  },

  components: {
    MagazineCard,
    MagazineCardList,
    HeadingLv3,
    Keywords
  },

  setup(props) {
    const { state, loadCategory } = useSpecial()

    if (!state.categories.length) loadCategory()
    const categoryList = computed(() => {
      if (props.categories.length) return props.categories
      return [...state.seriesCategories, ...state.specialCategories]
    })
    const categoryListItems = computed(() =>
      categoryList.value.map((cat) => ({
        id: cat.id,
        path: cat.path,
        title: cat.name,
        image: cat.spThumbUrl,
        imageAlt: cat.spThumbAlt
      }))
    )

    return {
      categoryListItems
    }
  }
})
